import React, { FC } from 'react'

import styled from 'styled-components'

import { createEventListPath } from 'components/page/EventList/function/createEventListPath'
import { useHitsCounter } from 'components/page/EventList/hook/useHitsCounter'
import { MambaRouterLink } from 'components/presentational/Navigation/Link/LinkMambaRu.styled'
import { NavigationCounter } from 'components/presentational/Navigation/NavigationCounter/NavigationCounter'
import { EventDefaultSvg } from 'components/presentational/svg/EventDefaultSvg'

export const MobileHitListLink: FC<{ className?: string }> = ({
  className,
}) => {
  const fullUrl = createEventListPath()
  const hitsCounter = useHitsCounter()

  return (
    <LinkWrapper className={className}>
      <MambaRouterLink to={fullUrl} data-name="hitlist-action">
        <NavigationCounter counter={hitsCounter} data-name="hitlist-counter">
          <EventDefaultSvg />
        </NavigationCounter>
      </MambaRouterLink>
    </LinkWrapper>
  )
}

const LinkWrapper = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  font-size: 15px;
  z-index: 1;
`
